import Views from "./views/Views.vue";
import ModelEditor from "./views/ModelEditor.vue";

const moduleRoutes = [
	{
		path: "/:domainId/information-model",
		name: "Information Model",
		component: Views,
	},
	{
		path: "/:domainId/information-model/:viewId",
		name: "Information Model Editor",
		component: ModelEditor,
	},
];

export default moduleRoutes;
